import { createReducer, on } from '@ngrx/store';
import { ProjectJobServiceCreateResponseJson } from '@vmspdb/definitions';
import * as ProjectJobsActions from './project-jobs.actions';

export const projectJobsFeatureKey = 'projectJobs';

export interface State {
  projectUuid: string;
  loading: boolean;
  jobs: ProjectJobServiceCreateResponseJson[];
  error: any | null;
}

export const initialState: State = {
  projectUuid: '',
  loading: false,
  jobs: [],
  error: null,
};

export const reducer = createReducer(
  initialState,

  on(ProjectJobsActions.loadProjectJobs, (state: State): State => ({
    ...state,
    loading: true,
    jobs: [],
    error: null,
  })),

  on(
    ProjectJobsActions.setProjectJobs,
    (state: State, { projectJobs }): State => ({
      ...state,
      loading: false,
      jobs: projectJobs,
      error: null,
    }),
  ),
);
